module.exports = {
  CLIENT_COOKIES: 'client-cookies',
  WEB_VITALS: 'web-vitals',
  RESOURCE_TIMING: 'resource-timing',
  PAGE_RENDER: 'page-render',
  A11Y: 'a11y',
  AVAILABILITY: 'availability',
  CDN_HEALTH: 'cdn-health',
  TRAFFIC_HEALTH: 'traffic-health',
  SESSION_REPLAY: 'session-replay',
};
